import { ITransitions } from './ITransitions';

export const transitions: ITransitions = {
  speed: {
    slow: '1s',
    normal: '300ms',
    fast: '150ms',
  },
};
